<template>
  <div>
    <editor v-model="myValue" :init="init" :disabled="disabled" @onClick="onClick"></editor>
  </div>
</template>
<script >
import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import Bus from "@/JS/Bus"; 
import wxCardAct from "@/Entity/weixin/WxCard"; //微信卡券处理方法
import "tinymce/themes/silver";
import { getCookie, setCookie, delCookie } from "@/JS/cookie"; //使用getCookie方法
import httpApi from "@/API/Tenant/Weixin"; //上传图片
import { log } from "util";

// 编辑器插件plugins
// 更多插件参考：https://www.tiny.cloud/docs/plugins/
import "tinymce/plugins/image"; // 插入上传图片插件
import "tinymce/plugins/media"; // 插入视频插件
import "tinymce/plugins/table"; // 插入表格插件
import "tinymce/plugins/lists"; // 列表插件bdmap
import "tinymce/plugins/wordcount"; // 字数统计插件
import "tinymce/plugins/code"; // 查看源码
import "tinymce/plugins/emoticons"; // 表情图标
import "tinymce/plugins/link"; //超链接
import "tinymce/plugins/preview"; //预览
import "tinymce/plugins/advlist";
import "tinymce/plugins/anchor";
import "tinymce/plugins/template";
import "tinymce/plugins/hr";

//import "tinymce/plugins/formatpainter";
// import "tinymce/plugins/checklist";
import "tinymce/plugins/insertdatetime";
// import "tinymce/plugins/";
// import "tinymce/plugins/";
// import "tinymce/plugins/";
// import "tinymce/plugins/";
// import "tinymce/plugins/";
// import "tinymce/plugins/";
// import "tinymce/plugins/";
// import "tinymce/plugins/";
// import "tinymce/plugins/";
// import "tinymce/plugins/";
// import "tinymce/plugins/";
// import "tinymce/plugins/";
// import "tinymce/plugins/";
export default {
  components: {
    Editor
  },

  props: {
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: [String, Array],
      default:
        "lists image media table wordcount code  link preview formatpainter template checklist hr formatpainter emoticons  "
    },
    menubar: {
      type: [String, Array],
      default: "insert view"
    },
    templates: [
      {
        title: "Some title 1",
        description: "Some desc 1",
        content: "My content"
      },
      {
        title: "Some title 2",
        description: "Some desc 2",
        url: "development.html"
      }
    ],
    toolbar: {
      type: [String, Array],
      default:
        "undo redo | fontselect fontsizeselect hr | blockquote removeformat formatpainter  | link unlink openlink  emoticons | table   code |  bold  italic  underline strikethrough forecolor backcolor   |   alignleft aligncenter alignright alignjustify alignnone   | bullist numlist indent outdent  checklist    formatpainter    | subscript superscript |   formatselect  | lists image   insertvideo insertmusic   insertcard   preview "
    }
    //media template insertvote insertapplets
  },
  data() {
    return {
      init: {
        language_url: "/static/tinymce/langs/zh_CN.js", //public目录下
        language: "zh_CN",
        skin_url: "/static/tinymce/skins/ui/oxide", //public目录下
        height: 600,
        //width: 680,
        //code_dialog_height:200,
        dialog_width: 600,
        plugins: this.plugins, // 父组件传入 或者 填写个默认的插件 要选用什么插件都可以 去官网可以查到
        toolbar: this.toolbar, // 工具栏 我用到的也就是lists image media table wordcount 这些 根据需求而定
        images_upload_url: "", //上传路径
        menubar: false, //最上方menu
        inline: false, //
        statusbar: false, //状态栏
        toolbar_drawer: false, //工具栏浮动
        fontsize_formats:
          "10px 11px 12px 13px 14px 15px 16px 17px 18px 19px 20px 24px 28px 32px 36px",
        //配置字体
        font_formats:
          "默认='Helvetica Neue', Helvetica, 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;Optima-Regular(中文细体)=Optima-Regular, PingFangTC-light;Arial=arial,helvetica,sans-serif;Zapfino=Zapfino;Futura-Medium=Futura-Medium;MarkerFelt-Thin=MarkerFelt-Thin;Cochin-BoldItalic=Cochin-BoldItalic;CourierNewPS-ItalicMT=", //'微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif',
        //配置表情
        emoticons_database_url:
          "/static/tinymce/plugins/emoticons/js/emojis.js",
        //启用菜单栏并显示如下项 [文件 编辑 插入 格式 表格]
        // menubar: "file edit insert view format table",
        // 配置每个菜单栏的子菜单项（如下是默认配置）
        /*menu: {
          file: { title: "File", items: "newdocument" },
          edit: {
            title: "Edit",
            items: "undo redo | cut copy paste pastetext | selectall"
          },
          insert: { title: "Insert", items: "link media | template hr" },
          view: { title: "View", items: "visualaid" },
          format: {
            title: "Format",
            items:
              "bold italic underline strikethrough superscript subscript | formats | removeformat"
          },
          table: {
            title: "Table",
            items: "inserttable tableprops deletetable | cell row column"
          }
        }*/
        // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
        // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
        setup: editor => {
          //console.log(editor);
          //取页面传过来的视频资源
          let wxVideoitems;
          Bus.$on("wxVideo", Item => {
            wxVideoitems = Item;
            //console.log(Item);
          });
          if (!wxVideoitems) {
            wxVideoitems = [];
          }
          //取页面传过来的语音资源
          let wxVoiceitems;
          Bus.$on("wxVoice", Item => {
            wxVoiceitems = Item;
            // console.log(Item);
          });
          if (!wxVoiceitems) {
            wxVoiceitems = [];
          }
          //插入视频
          let isUrl = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
          let videoRegular = /https:\/\/v.qq.com?/i; //
          editor.ui.registry.addButton("insertvideo", {
            text:
              "<i class='el-icon-video-camera' style='font-size:18px'><span  style='font-size:14px;padding:0 0 10px 0'> 视频</span></i>",
            tooltip: "插入视频",
            onAction: function() {
              tinymce.activeEditor.windowManager.open({
                title: "选择视频", // The dialog's title - displayed in the dialog header
                body: {
                  type: "tabpanel", // The root body type - a Panel or TabPanel
                  tabs: [
                    {
                      name: "mytab1",
                      title: "素材视频",
                      items: [
                        {
                          type: "panel", // component type
                          items: wxVideoitems
                        },
                        {
                          type: "button", // component type
                          text: "ok",
                          primary: true,
                          name: "wxVideo-button"
                          // disabled: true,
                          //borderless: false
                        }
                      ]
                    },
                    {
                      name: "mytab2",
                      title: "插入视频",
                      items: [
                        {
                          type: "input",
                          name: "videoUrl",
                          label: "视频网址(微信图文仅支持腾讯视频链接)",
                          placeholder: "如：(https://v.qq.com/x/*/*.html)"
                        },
                        {
                          type: "button", // component type
                          text: "ok",
                          primary: true,
                          name: "qqVideo-button"
                          // disabled: true,
                          //borderless: false
                        }
                      ]
                    }
                  ]
                },
                buttons: [
                  {
                    type: "cancel",
                    name: "closeButton",
                    text: "Cancel"
                  }
                ],
                initialData: {
                  videoUrl: ""
                },
                onChange: function(api, e) {
                  //console.log(api);
                  //console.log(api.getData());
                  //console.log(e);
                },
                onAction: function(api, e) {
                  //console.log(e.name);
                  if (e.name == "qqVideo-button") {
                    //上传腾讯视频
                    var data = api.getData();
                    if (data.videoUrl == "") {
                      tinymce.activeEditor.windowManager.alert(
                        "请输入腾讯视频地址！"
                      );
                      //this.$message.error("请输入腾讯视频地址！");
                      return;
                    }
                    if (data.videoUrl.match(isUrl) == null) {
                      tinymce.activeEditor.windowManager.alert(
                        "请输入正确网址！"
                      );
                      return;
                    }
                    let len = data.videoUrl.match(videoRegular);
                    if (len == null) {
                      tinymce.activeEditor.windowManager.alert(
                        "请输入腾讯视频地址！"
                      );
                      return;
                    }
                    // tinymce.activeEditor.execCommand(
                    //   "mceInsertContent",
                    //   false,
                    //   '<iframe frameborder="0" src="' +
                    //     data.videoUrl +
                    //     '" allowFullScreen="true" height="323" width="574"></iframe>'
                    // );
                    var tempUrlLen = data.videoUrl.indexOf(
                      "https://v.qq.com/x/"
                    );
                    if (tempUrlLen == -1) {
                      tinymce.activeEditor.windowManager.alert(
                        "请输入腾讯视频地址！(https://v.qq.com/x/*/*.html)"
                      );
                      return;
                    }
                    var arry = data.videoUrl.split("/");
                    if (arry.length < 1) {
                      tinymce.activeEditor.windowManager.alert(
                        "请输入腾讯视频地址！(https://v.qq.com/x/*/*.html)"
                      );
                      return;
                    }
                    var listData = arry[arry.length - 1].split(".");
                    if (listData.length < 1) {
                      tinymce.activeEditor.windowManager.alert(
                        "请输入腾讯视频地址！(https://v.qq.com/x/*/*.html)"
                      );
                      return;
                    }
                    data.videoUrl =
                      "https://v.qq.com/txp/iframe/player.html?vid=" +
                      listData[0];
                      /*<iframe class="video_iframe wx_video_iframe rich_pages" data-vidtype="1" data-cover="http%3A%2F%2Fshp.qpic.cn%2Fqqvideo_ori%2F0%2Fz3052m476fc_496_280%2F0" allowfullscreen="" frameborder="0" style="position:relative; z-index:1;" height="323" width="574" src="/cgi-bin/readtemplate?t=tmpl/video_tmpl&amp;vid=z3052m476fc" data-ratio="1.7777777777777777" data-w="640"></iframe> */
                    tinymce.activeEditor.execCommand(
                      "mceInsertContent",
                      false,
                      '<iframe class="video_iframe wx_video_iframe rich_pages" data-vidtype="1" data-cover="http%3A%2F%2Fshp.qpic.cn%2Fqqvideo_ori%2F0%2F' +
                        listData[0] +
                        '_496_280%2F0" allowfullscreen="" frameborder="0" style="position:relative; z-index:1;border:none" height="323" width="574"  data-src="/cgi-bin/readtemplate?t=tmpl/video_tmpl&vid='+listData[0]+'"  src="' +
                        data.videoUrl +
                        '" data-ratio="1.7777777777777777" data-w="864"  style="border:none"></iframe>'
                    ); //
                    api.close();
                  } else if (e.name == "wxVideo-button") {
                    //公众号素材库资源
                    let urlData = [];
                    var data = api.getData();
                    //console.log(data);
                    var attryStr = JSON.stringify(data)
                      .replace("{", "")
                      .replace("}", "")
                      .replace(/"/g, "");
                    //console.log(attryStr);

                    var arrtay = attryStr.split(",");

                    arrtay.forEach(e => {
                      var temp = e.split(":");
                      //console.log(temp);
                      if (temp.length == 3) {
                        //console.log(temp[2]);

                        if (temp[2] == "true") {
                          //console.log(temp[1]);
                          var tempArry = temp[1].split("%_%_%");
                          // console.log(tempArry);
                          if (tempArry[0]) {
                            var tempArry = tempArry[0].split("&");
                            //console.log(tempArry);
                            tempArry.forEach(async a => {
                              var tempUrl = a.split("=");
                              //console.log(tempUrl);
                              if (tempUrl[0] == "vid") {
                                //console.log(tempUrl[1]);
                                //提取公众号视频资源地址
                                var params = {
                                  Input: [
                                    //{ Name: "aid", value: this.GetAppData.Aid },
                                    {
                                      Name: "url",
                                      value:
                                        "https://mp.weixin.qq.com/mp/videoplayer?action=get_mp_video_play_url&preview=0&__biz=&mid=&idx=&vid=" +
                                        tempUrl[1] +
                                        "&uin=&key=&pass_ticket=&wxtoken=&appmsg_token=&x5=0&f=json"
                                    }
                                  ]
                                };

                                // console.log(params);
                                var res = await httpApi.GetHtmlUrl(params);
                                // console.log(res);
                                if (res.ErrorCode == 0) {
                                  let wxVideoArry = JSON.parse(
                                    res.output[0].value
                                  ).url_info;
                                  var wxVideoUrlData = wxVideoArry[2];
                                  console.log(wxVideoUrlData.url);
                                  let html =
                                    '<iframe class="video_iframe rich_pages" src="' +
                                    wxVideoUrlData.url +
                                    '" width="' +
                                    wxVideoUrlData.width +
                                    '" height="' +
                                    wxVideoUrlData.height +
                                    '" data-honeframeborder="0" data-honescrolling="no" data-honeallowfullscreen="allowfullscreen" data-honedata-vidtype="5" data-honedata-mpvid="' +
                                    tempUrl[1] +
                                    '" data-honedata-cover="https://mp.weixin.qq.com/mp/videoplayer?action=get_mp_video_cover&vid=' +
                                    tempUrl[1] +
                                    '" data-ratio="0.5625" data-w="1080" data-src="https://mp.weixin.qq.com/mp/readtemplate?t=pages/video_player_tmpl&amp;action=mpvideo&amp;auto=0&amp;vid=' +
                                    tempUrl[1] +
                                    '" style="border:none"></iframe>';
                                  console.log(html);

                                  tinymce.activeEditor.execCommand(
                                    "mceInsertContent",
                                    false,
                                    html
                                  );
                                }
                              }
                            });
                          }
                          /*
                          //var temurl=temp[1];
                          var tempArry = temp[1].split("&");
                          tempArry.forEach(a => {
                            var tempUrl = a.split("=");
                            //console.log(tempUrl);
                            if (tempUrl[0] == "vid") {
                              // console.log(tempUrl[1]);
                              //console.log(wxVideoitems);
                              wxVideoitems.forEach(b => {
                                if (b.vid == tempUrl[1]) {
                                  data.videoUrl = b.value;
                                }
                              });
                              //data.videoUrl ="https://mp.weixin.qq.com/mp/readtemplate?t=pages/video_player_tmpl&action=mpvideo&vid="+ tempUrl[1]+"&auto=1";
                              tinymce.activeEditor.execCommand(
                                "mceInsertContent",
                                false,
                                '<iframe src="' +
                                  data.videoUrl +
                                  '" height="323" width="574" data-vid="' +
                                  tempUrl[1] +
                                  '"></iframe>'
                              );
                            }
                          });*/
                          //console.log(tempArry);
                        }
                      }
                    });
                    api.close();
                    //console.log(arrtay);
                  } else {
                    api.close();
                  }
                }
              });
            },
            onSubmit: function(api) {
              //var data = api.getData();
              api.close();
              //editor.insertContent(toDateHtml(new Date()));
            }
          });

          //插入音乐
          editor.ui.registry.addButton("insertmusic", {
            text:
              "<i class='el-icon-mic' style='font-size:18px'><span  style='font-size:14px;padding:0 0 10px 0'> 音频</span></i>",
            tooltip: "插入音频",
            onAction: function() {
              //console.log(wxVoiceitems);
              if (wxVoiceitems.length > 0) {
                page1Config.body.tabs[0].items[0].items = wxVoiceitems;
              }
              //console.log(page1Config);

              tinymce.activeEditor.windowManager.open(page1Config);
            }
          });
          //投票
          editor.ui.registry.addButton("insertvote", {
            text:
              "<i class='el-icon-s-data' style='font-size:18px'><span  style='font-size:14px;padding:0 0 10px 0'> 投票</span></i>",
            tooltip: "发起投票",
            onAction: function() {
              tinymce.activeEditor.windowManager.open({
                title: "发起投票", // The dialog's title - displayed in the dialog header
                body: {
                  type: "panel", // The root body type - a Panel or TabPanel
                  items: [
                    // A list of panel components
                    {
                      type: "htmlpanel", // A HTML panel component
                      html:
                        '<div class="mini_tips weak_text img_water_tips r">只可以选择已发布且在有效期内的投票，若投票未发布，请在<a href="javascript:;" class="js_manage_vote">投票管理</a>发布投票<a class="btn btn_default js_new_vote" target="_blank">新建投票</a></div><table  width=\'100%\'  border="1" cellspacing="0" cellpadding=\'20\'  class=\'csstable\'><thead><tr  class=\'csstabletr\'><th class=\'csstabletrtd\'>投票名称</th><th class=\'csstabletrtd\'>截至时间</th><th class=\'csstabletrtd\'>投票人数</th></tr></thead><tbody><tr><td class="empty_tips" colspan="3"  style=\'text-align: center;padding:90px 0\'>暂无有效投票</td></tr></tbody></table>'
                    }
                  ]
                },
                buttons: [
                  // A list of footer buttons
                  {
                    type: "submit",
                    text: "OK"
                  }
                ],
                initialData: {
                  videoUrl: ""
                },
                onChange: function(api, e) {
                  //console.log(api);
                  //console.log(api.getData());
                  //console.log(e);
                },
                onSubmit: function(api) {
                  //var data = api.getData();
                  api.close();
                  //editor.insertContent(toDateHtml(new Date()));
                }
              });
            }
          });
          //卡券
          //取页面传过来的卡券数据
          let wxCarditems;
          Bus.$on("wxCardData", async Item => {
            wxCarditems = Item;
            //console.log(Item);
          });
          if (!wxCarditems)
            wxCarditems = [
              {
                type: "htmlpanel", // component type
                html:
                  "<div style='text-align: center;padding:90px 0;'>暂无卡券数据！</div>"
              },
              // {
              //   type: "htmlpanel", // component type
              //   html:
              //     "<div style='font-size:14px'>注意：因微信有防盗链限制可能会出现无法显示LOGO，但发布后可以正常显示！</div>"
              // },
              {
                type: "button", // component type
                text: "获取最新卡券信息",
                primary: true,
                name: "wxCard-button"
                // disabled: true,
                //borderless: false
              }
            ];
          let wxBiz;
          Bus.$on("wxBiz", async Item => {
            wxBiz = Item;
            //console.log(Item);
          });
          editor.ui.registry.addButton("insertcard", {
            text:
              "<i class='el-icon-bank-card' style='font-size:18px'><span  style='font-size:14px;padding:0 0 10px 0'> 卡券</span></i>",
            tooltip: "插入卡券",
            onAction: function() {
              pageCardConfig.body.items = wxCarditems;
              console.log(pageCardConfig);
              tinymce.activeEditor.windowManager.open(pageCardConfig);
            }
          });
          //小程序
          editor.ui.registry.addButton("insertapplets", {
            text:
              "<i class='el-icon-link' style='font-size:18px'><span  style='font-size:14px;margin:0px 0 10px 0'> 小程序</span></i>",
            tooltip: "选择小程序",
            onAction: function() {
              tinymce.activeEditor.windowManager.open({
                title: "选择小程序", // The dialog's title - displayed in the dialog header
                body: {
                  type: "panel", // The root body type - a Panel or TabPanel
                  items: [
                    // A list of panel components
                    {
                      type: "panel", // A HTML panel component
                      items: [
                        {
                          type: "input",
                          name: "appletsUrl",
                          label: "",
                          placeholder:
                            "请输入要搜索的小程序名称/AppID/帐号原始ID"
                        },
                        {
                          type: "htmlpanel", // A HTML panel component
                          html: "常用"
                        }
                      ]
                    }
                  ]
                },
                buttons: [
                  // A list of footer buttons
                  {
                    type: "submit",
                    text: "OK"
                  }
                ],
                initialData: {
                  videoUrl: ""
                },
                onChange: function(api, e) {
                  //console.log(api);
                  //console.log(api.getData());
                  //console.log(e);
                },
                onSubmit: function(api) {
                  //var data = api.getData();
                  api.close();
                  //editor.insertContent(toDateHtml(new Date()));
                }
              });
            }
          });
          //
          //音乐搜索前
          var page1Config = {
            title: "选择音频", // The dialog's title - displayed in the dialog header
            body: {
              type: "tabpanel", // The root body type - a Panel or TabPanel
              tabs: [
                {
                  name: "mytab1",
                  title: "素材音频",
                  items: [
                    {
                      type: "panel", // component type
                      items: wxVoiceitems
                    },
                    {
                      type: "button", // component type
                      text: "ok",
                      primary: true,
                      name: "wxMusic-button"
                      // disabled: true,
                      //borderless: false
                    }
                  ]
                },
                {
                  name: "mytab2",
                  title: "QQ音乐",
                  items: [
                    {
                      type: "input",
                      name: "musicKey",
                      label: "输入歌手/歌曲/专辑，搜索您感兴趣的音乐！",
                      placeholder: "输入歌手/歌曲/专辑",
                      size: "large"
                    },
                    // {
                    //   type: "htmlpanel",
                    //   html: "<p>选择音乐</p>"
                    // },
                    {
                      type: "button", // component type
                      text: "搜索歌曲",
                      primary: true,
                      name: "qqMusicSearch-button"
                      // disabled: true,
                      //borderless: false
                    }
                  ]
                }
              ]
            },
            buttons: [
              {
                type: "cancel",
                name: "closeButton",
                text: "Cancel"
              }
            ],
            initialData: {
              musicKey: "",
              musicpageSize: 15, //搜索页面数
              musicpages: 1 //当前第几页
            },
            onAction: async function(api, e) {
              // console.log(e.name);

              var data = api.getData();
              //  console.log(page2Config)
              //公众号语音
              if (e.name == "wxMusic-button") {
                let insertMusic = [];
                let resultData = JSON.stringify(api.getData());
                resultData = resultData.substr(1, resultData.length - 2);
                resultData = resultData.replace(/\"/g, "");
                //console.log(resultData);
                let tempArry = resultData.split(",");
                tempArry.forEach(x => {
                  // console.log(x);
                  let array = x.split(":");
                  if (array.length == 2) {
                    if (array[1] == "true") {
                      insertMusic.push(array[0]);
                    }
                  }
                });
                // console.log(insertMusic);
                // if (insertMusic.length == 0) {
                //   tinymce.activeEditor.windowManager.alert(
                //     "请选择要插入的语音"
                //   );
                //   return;
                // }
                insertMusic.forEach(x => {
                  var temp = x.split("%_%_%");
                  let str =
                    '<iframe class="js_editor_audio audio_iframe res_iframe js_uneditable custom_select_card" src="/wx-VoiceDetail?t=tmpl/audio_tmpl&amp;name=' +
                    temp[1] +
                    '" data-honeisaac2="1" data-honelow_size="33.53" data-honesource_size="33.5" data-honehigh_size="18.61" data-honename="' +
                    decodeURIComponent(temp[1]) +
                    '" data-honeplay_length="18000" data-honevoice_encode_fileid="' +
                    temp[2] +
                    '"  height="110" width="750" frameborder="0"  style="border:none"></iframe>';
                  tinymce.activeEditor.execCommand(
                    "mceInsertContent",
                    false,
                    str
                  );
                });
                api.close();
              }
              if (e.name == "qqMusicSearch-button") {
                if (data.musicKey == "") {
                  tinymce.activeEditor.windowManager.alert(
                    "请输入歌手/歌曲/专辑！"
                  );
                } else {
                  //搜索音乐
                  var params = {
                    Input: [
                      //{ Name: "aid", value: this.GetAppData.Aid },
                      {
                        Name: "url",
                        value:
                          "https://c.y.qq.com/soso/fcgi-bin/client_search_cp?aggr=1&cr=1&flag_qc=0&w=" +
                          data.musicKey +
                          "&p=1&n=15"
                      }
                    ]
                  };
                  // console.log(params);
                  var res = await httpApi.GetHtmlUrl(params);
                  if (res.ErrorCode == 0) {
                    var tempResult = res.output[0].value.replace(
                      "callback(",
                      ""
                    );
                    tempResult = tempResult.substring(0, tempResult.length - 1);
                    var reuslt = JSON.parse(tempResult);

                    if (reuslt.code != 0) {
                      tinymce.activeEditor.windowManager.alert(
                        "读取失败:" + reuslt.message
                      );
                    } else {
                      page2Config.body.items = [];
                      //解析数据
                      var reusltData = reuslt.data.song.list;
                      //console.log(reusltData);
                      // page2Config.initialData.search_music = {
                      //   key: data.musicKey,
                      //   data: reuslt.data.song.list
                      // };
                      let dataList = [];
                      //取音乐资源文件播放用
                      let playMusicData = [];
                      reusltData.forEach(x => {
                        playMusicData.push(x.songmid);
                      });
                      //console.log(playMusicData);
                      let guid = new Date().getTime(); //获取时间戳
                      let playMusDataParam = {
                        req: {
                          module: "CDN.SrfCdnDispatchServer",
                          method: "GetCdnDispatch",
                          param: { guid: guid, calltype: 0, userip: "" }
                        },
                        req_0: {
                          module: "vkey.GetVkeyServer",
                          method: "CgiGetVkey",
                          param: {
                            guid: guid,
                            songmid: playMusicData,
                            songtype: [0],
                            uin: "0",
                            loginflag: 1,
                            platform: "20"
                          }
                        },
                        comm: { uin: 0, format: "json", ct: 24, cv: 0 }
                      };
                      let palyParamsData = JSON.stringify(playMusDataParam);
                      palyParamsData = encodeURIComponent(palyParamsData);
                      //console.log(palyParamsData);
                      //搜索音乐
                      var palyParams = {
                        Input: [
                          //{ Name: "aid", value: this.GetAppData.Aid },
                          {
                            Name: "url",
                            value:
                              "https://u.y.qq.com/cgi-bin/musicu.fcg?-=getplaysongvkey55777273125062&g_tk=5381&loginUin=0&hostUin=0&format=json&inCharset=utf8&outCharset=utf-8&notice=0&platform=yqq.json&needNewCode=0&data=" +
                              palyParamsData
                          }
                        ]
                      };
                      // console.log(palyParams);
                      var palyRes = await httpApi.GetHtmlUrl(palyParams); //请求取播放资源文件地址
                      //console.log(res);
                      if (palyRes.ErrorCode == 0) {
                        var tempPalyResult = JSON.parse(
                          palyRes.output[0].value
                        );
                        console.log(tempPalyResult);
                      }
                      reusltData.forEach(x => {
                        //console.log(x);
                        //let valueData = JSON.stringify(x);
                        var labelStr =
                          "<span class='csstabletrspan'>【歌名】" + x.songname;
                        if (x.lyric) {
                          labelStr = labelStr + "【来源】" + x.lyric;
                        }
                        if (x.albumname) {
                          labelStr = labelStr + "【专集】" + x.albumname;
                        }
                        // if(labelStr.length>40){
                        //   labelStr=labelStr.substr(0,38)+"...";
                        // }
                        if (x.songurl) {
                          labelStr =
                            labelStr +
                            " <i class='el-icon-video-play' title='试听' style='cursor:pointer' onclick=window.open('" +
                            x.songurl +
                            "')></i></span>";
                        } else {
                          //labelStr = labelStr + " '版权限制无法试听";
                        }
                        if (x.albumid && x.albummid && x.songurl) {
                          page2Config.body.items.push({
                            type: "checkbox",
                            name:
                              x.albumid +
                              "_" +
                              x.albummid +
                              "_" +
                              encodeURIComponent(x.songname) +
                              "_" +
                              encodeURIComponent(x.lyric) +
                              "_" +
                              encodeURIComponent(x.albumname) +
                              "_" +
                              x.songmid,
                            label: labelStr
                          });
                        }
                      });

                      //写入分页代码
                      /*  console.log(reuslt.data.song.totalnum);
                      let musicPageCount = reuslt.data.song.totalnum / 15;
                      if (reuslt.data.song.totalnum % 15 > 0) {
                        musicPageCount = musicPageCount + 1;
                      }
                      let selectboxData = [];
                      for (var i = 1; i < musicPageCount + 1; i++) {
                        selectboxData.push({
                          value: "" + i + "",
                          text: "第" + i + "页"
                        });
                      }

                      page2Config.body.items.push({
                        type: "selectbox", // component type
                        name: "musicpage", // identifier
                        label: "",
                        size: 1, // number of visible values (optional)
                        items: selectboxData
                      });*/
                      //page2Config.body.items[0].cells = dataList;
                      page2Config.title =
                        "搜索关键词<" + data.musicKey + ">结果";
                      //console.log(page2Config);
                      //没有数据
                      console.log(page2Config.body.items);

                      if (page2Config.body.items.length == 0) {
                        page2Config.body.items.push({
                          type: "htmlpanel",
                          html:
                            "<div  style='text-align: center;padding:90px 0'>没有搜索到<" +
                            data.musicKey +
                            ">相关音乐或<" +
                            data.musicKey +
                            ">版权限制！</div>"
                        });
                      }
                      api.redial(page2Config);
                    }
                  } else {
                    tinymce.activeEditor.windowManager.alert(
                      "请求失败：" + res.ErrorMessage
                    );
                  }
                  //console.log("搜索qq音乐");
                }
              }
            }
          };
          //音乐搜索后
          //var search_musicKey = "sdafs";

          var page2Config = {
            title: "搜索关键词<>结果",
            size: "medium",
            body: {
              type: "panel",
              items: [
                /*{
                  type: "table", // component type
                  header: ["", "歌曲", "歌手", "专辑", ""],
                  cells: [["Cell 1", "Cell 2", "Cell 3", "Cell 4", "Cell 5"]]
                }*/
                // {
                //   type: "checkbox",
                //   name: "isdog",
                //   label: "tick if cat is actually a dog"
                // }
              ]
            },
            buttons: [
              {
                type: "custom",
                name: "backButton",
                text: "返回"
              },
              {
                type: "custom",
                name: "lastpage",
                text: "ok",
                disabled: false
              }
            ],
            initialData: {
              Fruit: "",
              musicpage: "1"
            },
            //请求音乐资源地址：https://u.y.qq.com/cgi-bin/musicu.fcg?data=
            /*
            {"req":{"module":"CDN.SrfCdnDispatchServer","method":"GetCdnDispatch","param":{"guid":"8473510020","calltype":0,"userip":""}},"req_0":{"module":"vkey.GetVkeyServer","method":"CgiGetVkey","param":{"guid":"8473510020","songmid":["002vYYLP2oRUjQ","004VLTO14E8yom"],"songtype":[0],"uin":"0","loginflag":1,"platform":"20"}},"comm":{"uin":0,"format":"json","ct":24,"cv":0}}
            */
            onChange: async (dialogApi, details) => {
              //console.log(details);
              if (details.name == "musicpage") {
                let data = dialogApi.getData();
                //console.log(data.musicpage);
                //搜索音乐
                var params = {
                  Input: [
                    //{ Name: "aid", value: this.GetAppData.Aid },
                    {
                      Name: "url",
                      value:
                        "https://c.y.qq.com/soso/fcgi-bin/client_search_cp?aggr=1&cr=1&flag_qc=0&w=" +
                        data.musicKey +
                        "&p=" +
                        data.musicpage +
                        "&n=15"
                    }
                  ]
                };
                //console.log(params);
                var res = await httpApi.GetHtmlUrl(params);
                //console.log(res);
                if (res.ErrorCode == 0) {
                  var tempResult = res.output[0].value.replace("callback(", "");
                  tempResult = tempResult.substring(0, tempResult.length - 1);
                  var reuslt = JSON.parse(tempResult);
                  if (reuslt.code != 0) {
                    tinymce.activeEditor.windowManager.alert(
                      "读取失败:" + reuslt.message
                    );
                  } else {
                    page2Config.body.items = [];
                    //解析数据
                    var reusltData = reuslt.data.song.list;

                    let dataList = [];
                    reusltData.forEach(x => {
                      //console.log(x);
                      //let valueData = JSON.stringify(x);
                      var labelStr =
                        "<span class='csstabletrspan'>【歌名】" + x.songname;
                      if (x.lyric) {
                        labelStr = labelStr + "【来源】" + x.lyric;
                      }
                      if (x.albumname) {
                        labelStr = labelStr + "【专集】" + x.albumname;
                      }
                      if (x.songurl) {
                        labelStr =
                          labelStr +
                          " <i class='el-icon-video-play' title='试听' style='cursor:pointer' onclick=window.open('" +
                          x.songurl +
                          "')></i></span>";
                      } else {
                        //labelStr = labelStr + " '版权限制无法试听";
                      }
                      if (x.albumid && x.albummid) {
                        page2Config.body.items.push({
                          type: "checkbox",
                          name:
                            x.albumid +
                            "_" +
                            x.albummid +
                            "_" +
                            encodeURIComponent(x.songname) +
                            "_" +
                            encodeURIComponent(x.lyric) +
                            "_" +
                            encodeURIComponent(x.albumname) +
                            "_" +
                            x.songmid,
                          label: labelStr
                        });
                      }
                    });
                    //写入分页代码
                    //console.log(reuslt.data.song.totalnum);
                    let musicPageCount = reuslt.data.song.totalnum / 15;
                    if (reuslt.data.song.totalnum % 15 > 0) {
                      musicPageCount = musicPageCount + 1;
                    }
                    let selectboxData = [];
                    for (var i = 1; i < musicPageCount + 1; i++) {
                      selectboxData.push({
                        value: "" + i + "",
                        text: "第" + i + "页"
                      });
                    }

                    page2Config.body.items.push({
                      type: "selectbox", // component type
                      name: "musicpage", // identifier
                      label: "当前第" + data.musicpage + "页",
                      size: 1, // number of visible values (optional)
                      items: selectboxData
                    });
                    //page2Config.body.items[0].cells = dataList;
                    page2Config.title = "搜索关键词<" + data.musicKey + ">结果";
                    //console.log(page2Config);
                    dialogApi.redial(page2Config);
                  }
                }
              }
            },
            onAction: (dialogApi, details) => {
              if (details.name == "backButton") {
                dialogApi.redial(page1Config);
              } else {
                //查询选中的内容
                let insertMusic = [];
                let resultData = JSON.stringify(dialogApi.getData());
                resultData = resultData.substr(1, resultData.length - 2);
                resultData = resultData.replace(/\"/g, "");
                //console.log(resultData);
                let tempArry = resultData.split(",");
                tempArry.forEach(x => {
                  //console.log(x);
                  let array = x.split(":");
                  //console.log(array);
                  if (array.length == 2) {
                    if (array[1] == "true") {
                      //需要插入的内容
                      //console.log(array[0]);
                      insertMusic.push(array[0]);
                    }
                  }
                });
                if (insertMusic.length == 0) {
                  tinymce.activeEditor.windowManager.alert(
                    "请选择要插入的音乐"
                  );
                  return;
                }
                insertMusic.forEach(x => {
                  var temp = x.split("_");
                  console.log(temp);
                  let strphoto =
                    "https://y.gtimg.cn/music/photo_new/T002R90x90M000" +
                    temp[1] +
                    ".jpg";
                  let domain = window.location.host;
                  let urlpaes =
                    "singer=" +
                    encodeURIComponent(temp[3]) +
                    "&music_name=" +
                    encodeURIComponent(temp[2]) +
                    "&albumurl=" +
                    encodeURIComponent(strphoto) +
                    "&musictype=1";
                  let str =
                    '<iframe class="js_editor_qqmusic qqmusic_iframe res_iframe js_uneditable custom_select_card" src="http://' +
                    domain +
                    "/wx-MusicDetail?" +
                    urlpaes +
                    '"  data-src="https://mp.weixin.qq.com/cgi-bin/readtemplate?t=tmpl/qqmusic_tmpl&' +
                    urlpaes +
                    '"  data-honemusicid="' +
                    temp[0] +
                    '" data-honemid="' +
                    temp[5] +
                    '" data-honealbumurl="' +
                    strphoto +
                    '" data-honeaudiourl="" data-honemusic_name="' +
                    decodeURIComponent(temp[2]) +
                    '" data-honesinger="' +
                    decodeURIComponent(temp[3]) +
                    '" data-honeplay_length="262" data-honemusictype="1" data-honeotherid="" data-honealbumid="" frameborder="0" height="105"  width="750" style="border:none;" frameborder="0"  style="border:none"></iframe>';
                  tinymce.activeEditor.execCommand(
                    "mceInsertContent",
                    false,
                    str
                  );
                });
                /*
                  //http://isure.stream.qqmusic.qq.com/C200003CBp6o2eu269.m4a?guid=2000001731&amp;vkey=9104477357C83BECCC5C44F4A3E34461237507C5CB4334E77E43BF7C44ABE951D3EC0A05FB928A4AFDFB4B96EBEAE1DEA11F9C8E58EC7477&amp;uin=&amp;fromtag=50

                  tinymce.activeEditor.execCommand(
                    "mceInsertContent",
                    false,
                    '<iframe class="js_editor_qqmusic qqmusic_iframe res_iframe js_uneditable custom_select_card" src="https://mp.weixin.qq.com/cgi-bin/readtemplate?t=tmpl/qqmusic_tmpl&amp;singer=%e5%8e%9f%e5%94%b1%ef%bc%9a%e8%8e%ab%e6%96%87%e8%94%9a&amp;music_name=%e6%88%91%e6%98%af%e6%ad%8c%e6%89%8b%e7%ac%ac%e4%b8%89%e5%ad%a3+%e7%ac%ac11%e6%9c%9f&amp;albumurl=https%3a%2f%2fy.gtimg.cn%2fmusic%2fphoto_new%2fT002R68x68M0000003p8rea4EZOBR.jpg&amp;musictype=1" data-honemusicid="964827" data-honemid="003NHKOB0yeiv9" data-honealbumurl="https://y.gtimg.cn/music/photo_new/T002R68x68M0000003p8rea4EZOBR.jpg" data-honeaudiourl="" data-honemusic_name="爱" data-honesinger="莫文蔚&nbsp;-&nbsp;[i]" data-honeplay_length="200" data-honemusictype="1" data-honeotherid="003NHKOB0yeiv9" data-honealbumid="003p8rea4EZOBR"></iframe>'
                  );*/
                dialogApi.close();
              }
            }
          };
          //插入卡券
          var pageCardConfig = {
            title: "选择卡券", // The dialog's title - displayed in the dialog header
            body: {
              type: "panel", // The root body type - a Panel or TabPanel
              items: wxCarditems
            },
            buttons: [
              // A list of footer buttons
              {
                type: "submit",
                text: "OK"
              }
            ],
            initialData: {
              txtCardVal: ""
            },
            onChange: function(api, e) {
              //console.log(api);
              //console.log(api.getData());
              //console.log(e);
            },
            onAction: async function(api, e) {
              //console.log(e.name);
              if (e.name == "wxCard-button") {
                //console.log(params);
                pageCardConfig.body.items = [
                  {
                    type: "htmlpanel", // A HTML panel component
                    html:
                      "<div style='text-align: center;padding:90px 0'><i class='el-icon-loading' style='font-size:60px;'></i><br><br>卡券数据正在加载中，请稍等片刻...</div>"
                  }
                ];
                api.redial(pageCardConfig);
                let Aid = getCookie("Aid");
                let TenantID = getCookie("TenantID");
                let params = {
                  Input: [
                    {
                      Name: "account",
                      value: {
                        TenantID: TenantID,
                        Aid: Aid
                      }
                    },
                    {
                      Name: "statusList",
                      value: "CARD_STATUS_VERIFY_OK,CARD_STATUS_DISPATCH"
                    },
                    { Name: "Clear", value: 1 }, //是否重加载
                    //分页参数
                    { Name: "offset", value: 0 }, //跳过数量
                    { Name: "count", value: 50 }
                  ]
                };
                var res = await httpApi.GetWeiXinCardListAsync(params);
                if (res.ErrorCode == 0) {
                  let tempData = JSON.parse(res.output[0].value);
                  //console.log(tempData);
                  //wxcardItems = [];
                  let wxcardtempData = [];
                  wxcardtempData = wxCardAct.loadData(tempData);
                  //console.log(wxcardtempData);
                  pageCardConfig.body.items = wxcardtempData;
                  //alert("刷新卡券成功！");
                } else {
                  pageCardConfig.body.items = [
                    {
                      type: "htmlpanel", // A HTML panel component
                      html:
                        "<div style='text-align: center;padding:90px 0'>加载卡券失败： " +
                        res.ErrorMessage +
                        "</div>"
                    }
                  ];
                }
                api.redial(pageCardConfig);
                //console.log(res);

                // api.close();
              }
            },
            onSubmit: function(api) {
              var data = api.getData();
              //console.log(data);
              let insertCard = [];
              let resultData = JSON.stringify(api.getData());
              resultData = resultData.substr(1, resultData.length - 2);
              resultData = resultData.replace(/\"/g, "");
              //console.log(resultData);
              let tempArry = resultData.split(",");
              tempArry.forEach(x => {
                // console.log(x);
                let array = x.split(":");
                if (array.length == 2) {
                  if (array[1] == "true") {
                    insertCard.push(array[0]);
                  }
                }
              });
              //console.log(insertCard);
              // if (insertCard.length == 0) {
              //   tinymce.activeEditor.windowManager.alert("请选择要插入的卡券");
              //   return;
              // }
              //
              // if(this.myValue.indexOf("res_iframe card_iframe js_editor_card")!=-1){
              //   tinymce.activeEditor.windowManager.alert("一次只能选择一个卡券，请勿增加多个卡券！");
              //   return;
              // }
              // if(insertCard.length>1){
              //   tinymce.activeEditor.windowManager.alert("一次只能选择一个卡券，请勿多选！");
              //   return;
              // }
              let logo_url = "";
              let brand_name = "";
              let title = "";
              let color = "";
              let cardid = "";
              let card_type = "";
              var domain = window.location.host;
              insertCard.forEach(x => {
                var temp = x.split("|$$|");
                //console.log(temp);
                temp.forEach(a => {
                  //console.log(a);
                  let resList = a.split("|$|");
                  switch (resList[0]) {
                    case "logo_url":
                      logo_url = resList[1];
                      break;
                    case "brand_name":
                      brand_name = resList[1];
                      break;
                    case "title":
                      title = resList[1];
                      break;
                    case "color":
                      color = resList[1];
                      break;
                    case "cardid":
                      cardid = resList[1];
                      break;
                    case "card_type":
                      card_type = resList[1];
                      break;
                  }
                });
                //插入卡券代码 https://mp.weixin.qq.com/bizmall/appmsgcard?action=show&biz=MzI5NDMyOTc5MA==&cardid=pvntbxEPtNTFQiL6kV5J5xSNgJeg&wechat_card_js=1&pass_ticket=&scene=&msgid=100001531&msgidx=1&version=/mmbizwap/zh_CN/htmledition/js/appmsg/index4b110f.js&devicetype=&child_biz=MzI5NDMyOTc5MA==&wxtoken=777 https://mp.weixin.qq.com/cgi-bin/readtemplate?t=cardticket/card_preview_tmpl&amp;logo_url='+logo_url+'&brand_name='+brand_name+'&title='+title+'&color='+color+'&lang=zh_CN&cardid='+cardid+'

                //<iframe class="js_editor_card" src="https://mp.weixin.qq.com/bizmall/appmsgcard?action=show&amp;/cgi-bin/readtemplate?t=cardticket/card_preview_tmpl&amp;logo_url=https%3A%2F%2Fmmbiz.qlogo.cn%2Fmmbiz_png%2FCqOUIE8YTMNJvZRmumOXzeTUDWwibjX1Xc8vMcUayoWoZFH7VPJxHQ9icPB1YY3gpvFrDHyPSibu1VNXbSAJbO1mw%2F0%3Fwx_fmt%3Dpng&amp;brand_name=CRD%E5%85%8B%E5%BE%95%E5%B8%9D&amp;title=%E5%9B%A2%E8%B4%AD%E5%88%B8&amp;color=%239058CB&amp;lang=zh_CN&amp;cardid=pvntbxJ-ZZ2-7mBCXL2ChnTP3Eow&amp;token=938071325&amp;lang=zh_CN" width="574" height="190" frameborder="0" scrolling="no" data-cardid="pvntbxJ-ZZ2-7mBCXL2ChnTP3Eow" data-num="0" data-display-src="/cgi-bin/readtemplate?t=cardticket/card_preview_tmpl&amp;logo_url=https%3A%2F%2Fmmbiz.qlogo.cn%2Fmmbiz_png%2FCqOUIE8YTMNJvZRmumOXzeTUDWwibjX1Xc8vMcUayoWoZFH7VPJxHQ9icPB1YY3gpvFrDHyPSibu1VNXbSAJbO1mw%2F0%3Fwx_fmt%3Dpng&amp;brand_name=CRD%E5%85%8B%E5%BE%95%E5%B8%9D&amp;title=%E5%9B%A2%E8%B4%AD%E5%88%B8&amp;color=%239058CB&amp;lang=zh_CN&amp;cardid=pvntbxJ-ZZ2-7mBCXL2ChnTP3Eow&amp;token=938071325&amp;lang=zh_CN" data-src="http://mp.weixin.qq.com/bizmall/appmsgcard?action=show&amp;biz=MzI5NDMyOTc5MA==&amp;cardid=pvntbxJ-ZZ2-7mBCXL2ChnTP3Eow&amp;wechat_card_js=1#wechat_redirect"></iframe>
                //http://apitest.crdshop.cn/wxcrad.html
                ///tenants/wx-CradDetail
                let str =
                  '<iframe class="res_iframe card_iframe js_editor_card" scrolling="no" frameborder="0" data-cardid="' +
                  cardid +
                  '" data-num="0" src="http://' +
                  domain +
                  "/wx-CradDetail?action=show&logo_url=" +
                  logo_url +
                  "&brand_name=" +
                  brand_name +
                  "&title=" +
                  title +
                  "&color=" +
                  color +
                  "&lang=zh_CN&cardid=" +
                  cardid +
                  '" data-src="http://mp.weixin.qq.com/bizmall/appmsgcard?action=show&biz=' +
                  wxBiz +
                  "&cardid=" +
                  cardid +
                  "&wechat_card_js=1#wechat_redirect&r=" +
                  Math.random() +
                  '" data-src="http://mp.weixin.qq.com/bizmall/appmsgcard?action=show&amp;biz=' +
                  wxBiz +
                  "&amp;cardid=" +
                  cardid +
                  '&amp;wechat_card_js=1#wechat_redirect" height="190" width="750" frameborder="0" style="border:none"></iframe>';
                tinymce.activeEditor.execCommand(
                  "mceInsertContent",
                  false,
                  str
                );
              });
              api.close();
              //editor.insertContent(toDateHtml(new Date()));
            }
          };
        },

        // 官网抄的图片上传 项目如果用了vue-resource可以用$http 因为比较懒就没改
        images_upload_handler: async (blobInfo, success, failure) => {
          // console.log(blobInfo);
          // console.log(blobInfo.blob());

          let reader = new FileReader();
          reader.readAsDataURL(blobInfo.blob());

          let Aid = getCookie("Aid");
          let TenantID = getCookie("TenantID");
          if (!Aid || !TenantID) {
            return;
          }
          if (TenantID == 0) {
            return;
          }
          reader.onload = async e => {
            if (e.target) {
              let obj = e.target.result;
              console.log(obj);

              let params = {
                Input: [
                  {
                    Name: "Type",
                    value: "AppReplyImage"
                  },
                  {
                    Name: "FileName",
                    value: blobInfo.filename()
                  },
                  {
                    Name: "FileBase64",
                    value: obj
                  },
                  {
                    Name: "uploadWx",
                    value: 1
                  },
                  {
                    Name: "aid",
                    value: Aid
                  }
                ]
              };
              //console.log(params);
              var res = await httpApi.GetUpload(params);
              //console.log(res);
              if (res.ErrorCode == 0) {
                //加入选择编辑器
                /*
                this.stockcontentData.push({
                  MediaId: res.output[0].value.media_id,
                  UploadImage: res.output[0].value.url
                });
                */
                success(res.output[0].value.url);
                //   tinymce.activeEditor.selection.setContent("<img src='" +
                // res.output[0].value.url +
                // "' media_id='" +
                // res.output[0].value.media_id +
                // "' />");
                return;

                //this.AddaccountForm.CoverImage = res.output[0].value.url;
                //this.AddaccountForm.ThumbMediaId = res.output[0].value.media_id;
              } else {
                //this.$message.error("上传图片失败：" + res.ErrorMessage);
                return;
              }
            }
          };
          //console.log(failure);
        }
      },

      myValue: this.value
    };
  },
  created() {},
  mounted() {
    //console.log(this.emoticonsData);
    this.loademoticons();

    tinymce.init();
  },
  methods: {
    onClick(e) {
      this.$emit("onClick", e, tinymce);
    },
    //加载远程url内容
    async loadHtmlUrl(url) {},
    selectMusic(x) {
      console.log(x);
    },
    async loademoticons() {
      //拉取表情数据
      let tokendata = JSON.parse(localStorage.getItem("UserInfo"));
      //console.log(tokendata);

      var param = {
        Input: [
          {
            Name: "Enable",
            Value: "true"
          },
          {
            Name: "AppEmotionDTO",
            Value: {
              TenantID: tokendata.TenantID,
              EmotionName: ""
            }
          }
        ]
      };
      //console.log(param);
      var res = await httpApi.TinymceEmotionList(param);
      //console.log(res);
      if (res.ErrorCode == 0) {
        // let dateUpda = JSON.stringify(res.output[0].value);
        // dateUpda = dateUpda.substr(1, dateUpda.length - 2);
        // console.log(JSON.parse(dateUpda));
        // this.emoticonsData = res.output[0].value;
        tinymce.Resource.add("tinymce.plugins.emoticons", res.output[0].value);
      }
    }
  },
  watch: {
    value(newValue) {
      this.myValue = newValue;
    },
    myValue(newValue) {
      Bus.$emit("tinymceValue", newValue);
    }
  }
};
</script>
<style>
.tox-collection__item-icon img {
  width: auto !important;
  height: auto !important;
  max-width: 100% !important;
  max-height: 100% !important;
}
.tox-collection__item-icon {
  zoom: 1.5;
}
.tox-dialog__table td,
.tox-dialog__body,
.tox-checkbox-icon__checked {
  font-size: 12pt !important;
}
.tox-dialog__table th {
  white-space: nowrap;
}
.tox-dialog {
  max-width: 780px !important;
  overflow-x: hidden !important;
}
/*预览文章开始*/
.tox-dialog--width-lg {
  max-width: 750px !important;
}
.tox-dialog__body-content {
  max-height: 100% !important;
}
.tox-form__group--stretched {
  height: 100% !important;
}
.tox-navobj > iframe {
  height: 100% !important;
}
.tox-navobj > iframe img {
  max-width: 678px !important;
}
/*预览文章结束*/
.tox-dialog img {
  vertical-align: middle !important;
  max-width: 630px !important;
}
.musicPageCount li {
  float: left !important;
  width: 40px !important;
  text-align: center !important;
  border: #cccccc solid 1px !important;
  height: 25px !important;
  margin: 2px !important;
}
.csstable {
  width: 100% !important;
  border: 1px solid #ccc !important;
}
.csstable * {
  font-size: 14px !important;
}
.csstabletr {
  background-color: #f4f5f9 !important;

  height: 35px !important;
}
.csstabletrtd {
  padding: 10px !important;
  text-align: center !important;
  /*border-bottom: 1px solid #ccc !important;*/
}

.csstable td {
  text-align: center !important;
  height: 25px !important;
  padding: 15px 0 !important;
}
.weak_text {
  color: #9a9a9a !important;
  font-size: 14px !important;
  padding: 15px 0 !important;
}
/* .btn {
  padding: 5px 10px !important;
  border: 1px solid #e7e7eb !important;
  border-radius: 5px !important;
}
.btn:hover {
  background-color: #f4f5f9 !important;
} */
.btn_default {
  float: right !important;
  margin-top: -5px !important;
}
/*选择卡券模板 开始*/
.csstabletrspan {
  display: inline-block !important;
  padding: 10px 0 !important;
  font-size: 14px !important;
}
.tox-checkbox__label {
  width: 100% !important;
  /* border: 1px solid #ccc !important;
  border-top: none !important;
  border-left: none !important; */
}
/*卡券类型*/
.span0 {
  width: 30px !important;
}
.span1 {
  width: 90px !important;
}
/*卡券名称*/
.span2 {
  width: 150px !important;
}
/*卡券有效期*/
.span3 {
  width: 180px !important;
  color: #999 !important;
}
.span3 span,
.span6 span {
  color: #222 !important;
}
/*库存*/
.span4 {
  width: 60px !important;
  text-align: center !important;
}
/*微信价(元)*/
.span5 {
  width: 90px !important;
  text-align: center !important;
}
/*卡券状态*/
.span6 {
  width: 60px !important;
  text-align: center !important;
  color: #999 !important;
}
/*选择卡券模板 结束*/
</style>